import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {
    IVoceSchedaCosto
} from "../../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceSchedaCosto";
import {CustomAxiosError, useApiCalls} from "../../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../../utils/contexts/auth-context";


const useApiGetVociSchedaCosto = (scheda_costo_id: number | undefined): UseQueryResult<IVoceSchedaCosto[], CustomAxiosError> => {

    const {get} = useApiCalls()
    const {selectedCompany} = useAuth()

    async function doGet(): Promise<IVoceSchedaCosto[]> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/tannery_production/schede_costo/schede_costo/${scheda_costo_id}/voci_scheda_costo`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ['useApiGetVociSchedaCosto', scheda_costo_id],
        queryFn: () => doGet(),
        enabled: !!scheda_costo_id,
    })
};

export default useApiGetVociSchedaCosto